import { Card, Group, Stack, Tabs, Text, Title } from '@mantine/core'
import { useState } from 'react'
import { useTranslate } from 'react-admin'

import { Card as MUICard, CardContent } from '@mui/material'
import { CreateFileCopy } from './CreateFileCopy'
import styles from './FileCopy.module.scss'
import { FileCopyOperationsList } from './FileCopyOperationsList'

export const FileCopyPage = (): JSX.Element => {
  const t = useTranslate()
  const [activeTab, setActiveTab] = useState<string | null>('operations')
  const [refreshKey, setRefreshKey] = useState(0)

  return (
    <MUICard>
      <CardContent className={styles.container}>
        <Stack gap="md" pb="xl">
          <Group justify="space-between" align="center">
            <div>
              <Title order={2}>{t('pages.fileCopy._title')}</Title>
              <Text c="dimmed" size="sm">
                {t('pages.fileCopy.subtitle')}
              </Text>
            </div>
          </Group>

          <Tabs
            value={activeTab}
            onChange={setActiveTab}
            keepMounted={false}
            styles={{
              panel: {
                paddingTop: 'var(--mantine-spacing-md)',
              },
            }}
          >
            <Tabs.List>
              <Tabs.Tab value="operations">{t('pages.fileCopy.operationsTab')}</Tabs.Tab>
              <Tabs.Tab value="create">{t('pages.fileCopy.createTab')}</Tabs.Tab>
            </Tabs.List>

            <Tabs.Panel value="operations">
              <FileCopyOperationsList
                onGoToCreate={() => setActiveTab('create')}
                refreshKey={refreshKey}
              />
            </Tabs.Panel>

            <Tabs.Panel value="create">
              <CreateFileCopy
                onCreated={operationId => setRefreshKey(k => k + operationId.length)}
              />
            </Tabs.Panel>
          </Tabs>
        </Stack>
      </CardContent>
    </MUICard>
  )
}
